import * as source from './source'

export const login = (data)=>{
    return{
        type:"LOGIN_USER",
        payload:source.loginUser(data),
    }
}

export const setUser = (user)=>{
    return {
        type:"SET_USER",
        payload:user
    }
}